import { createSlice } from '@reduxjs/toolkit';
import { localVariables } from '../../../utils/constants.js';
import { authApi, usersApi } from '@/api/index.js';
import { getProfile } from './profileThunk.js';

const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        loadingProfile: 'idle',
        user: JSON.parse(localStorage.getItem(localVariables.USER)) || null
    },
    reducers: {
        saveProfileData: (state, data) => {
            const user = data.payload;
            state.user = user;

            state.loadingProfile = 'idle';
            usersApi.saveProfileData({ user });
        },
        clearProfileData: (state) => {
            state.user = null;

            state.loadingProfile = 'idle';
            usersApi.clearProfileData();
            authApi.clearAuthData();
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProfile.pending, (state) => {
                state.loadingProfile = 'loading';
            })
            .addCase(getProfile.rejected, (state, action) => {
                state.loadingProfile = 'failed';
            })
            .addCase(getProfile.fulfilled, (state, action) => {
                const user = action.payload.data;
                state.user = user;

                state.loadingProfile = 'idle';
                usersApi.saveProfileData({ user });
            });
    }
});

export const { saveProfileData, clearProfileData } = profileSlice.actions;
export default profileSlice.reducer;
